import { SetStateAction } from "react";
import { ModalWithButtons } from "./modal";
import { BlueButton, WhiteButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
}

export default function RemoveUserFromOrganizationModal(props: Props) {
	const { t: translation } = useTranslation();

	const modal: React.ReactNode = (
		<ModalWithButtons
			headerText={""}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<WhiteButton
					key="remove-user-from-organization-cancel-button"
					id="remove-user-from-organization-cancel-button"
					children={translation("Cancel")}
					onClick={() => {
						props.setOpen(false);
					}}
				></WhiteButton>,
				<BlueButton
					key="remove-user-from-organization-proceed-button"
					id="remove-user-from-organization-proceed-button"
					children={translation("Remove")}
					onClick={() => {
						setTimeout(() => props.proceedAction(), 1);
						props.setOpen(false);
					}}
				></BlueButton>,
			]}
		>
			<div className="modal-body-content">
				<div className="modal-body-icon discard-order-icon"></div>

				<div className="typography-body-01 typography-bold">
					{translation("RemoveUserAccess?")}
				</div>
				<div
					className="typography-body-01"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("RemoveUserConfirmMessage")}
				</div>
				<div
					className="typography-body-01"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("CannotUndoAction")}
				</div>
			</div>
		</ModalWithButtons>
	);

	return modal;
}
